import styled from 'styled-components';

export { DialogActionStyles, DialogButton, smallScreenSX } from '../dialogStyles';

export const Link = styled.a`
    text-decoration: none;
    color: #fff;
`;
